import React from 'react';
import styles from './FormattedPostText.module.css';
import {
  getFormattedPostElements,
} from '../../../../shared/utils/FeedHelpers';
import HyperLink from '../links/HyperLink.react';

const FormattedPostText = ({
  text,
  tagged,
  linkableUsers,
  history,
  clickable,
  links,
}) => {
  if ((!tagged || !tagged?.length) && (!links || !links?.length)) {
    return (
      <div className={styles.container}>
        <p className={`bodyCopy ${styles.postText}`}>{text}</p>
      </div>
    );
  }
  let expectedNames = [];
  for (let i = 0; i < tagged?.length; i++) {
    expectedNames.push(`${tagged[i].first_name} ${tagged[i].last_name}`);
  }

  const renderFormattedUsername = (formattedName, namesAreLinks) => {
    const userId = tagged[expectedNames.indexOf(formattedName)].id;
    return (
      <h3
        key={userId}
        className={styles.fullName}
        onClick={() =>
          clickable && history.push(`/profile/${userId}`)
        }>
        {/* avoid adding a space if the value after the name is a punctuation mark */}
        {`${formattedName}`}
      </h3>
    )
  };

  const renderHyperLink = (link) => {
    return <HyperLink key={link} link={link}/>
  }

  return (
    <div className={`bodyCopy ${styles.container}`}>
      {getFormattedPostElements(text, expectedNames, linkableUsers, renderFormattedUsername, links, renderHyperLink)}
    </div>
  );
};

export default FormattedPostText;
